import moment from 'moment';
import { numberUnmask, removeSpace, removeUnderline } from 'utils/masks';

export default {
  'debitCard.accountHolderName': [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (formData.isSelfSubmitted === 1 && (!formData.isDebitCardExisting || formData.isEditingDebitCard)) {
        if (!input || removeSpace(input).length === 0) {
          return 'The input field is required';
        }
      }
      return true;
    },
  }],
  'debitCard.cardNumber': [
    {
      rule: 'required',
      isValid: (input, err, opt, formData) => {
        if (formData.isSelfSubmitted === 1 && (!formData.isDebitCardExisting || formData.isEditingDebitCard)) {
          if (!input) {
            return 'The input field is required';
          }

          if (numberUnmask(input).length < 16) {
            return 'Card number is not valid';
          }

          if (
            !numberUnmask(input).startsWith('4')
            && !numberUnmask(input).startsWith('5')
            && !numberUnmask(input).startsWith('6')
          ) {
            return 'Currently we accept only Discover, Visa or Mastercard';
          }
        }
        return true;
      },
    },
  ],
  'debitCard.expirationDate': [
    {
      rule: 'required',
      isValid: (input, err, opt, formData) => {
        if (formData.isSelfSubmitted === 1 && (!formData.isDebitCardExisting || formData.isEditingDebitCard)) {
          if (!input) {
            return 'The input field is required';
          }

          if (numberUnmask(input).length < 4 || !moment(input, 'MM/YY').isValid()) {
            return 'Expiration Date is not valid';
          }

          const dateSplit = input.split('/');
          const normalizedDate = `${dateSplit[0]}/20${dateSplit[1]}`;

          return moment(normalizedDate, 'MM/YYYY').endOf('month').isSameOrBefore(moment().startOf('month')) ? 'Expiration Date is not valid' : true;
        }
      },
    },
  ],
  'owner.line1': [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (formData.avsFailed) {
        if (!input) {
          return 'The input field is required';
        }
      }
    },
  }],
  'owner.city': [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (formData.avsFailed) {
        if (!input) {
          return 'The input field is required';
        }
      }
    },
  }],
  'owner.state': [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (formData.avsFailed) {
        if (!input) {
          return 'The input field is required';
        }
      }
    },
  }],
  'owner.zipcode': [{
    rule: 'required',
    error: 'The input field is required',
    isValid: (input, err, opt, formData) => {
      if (formData.avsFailed) {
        if (!input || removeSpace(input).length === 0) {
          return 'The input field is required';
        }

        if (removeUnderline(input).length !== 5) {
          return 'Invalid zipcode';
        }
        return true;
      }
    },
  }],
  isSelfSubmitted: [{
    rule: 'required',
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }
      return true;
    },
  }],
  'bankAccount.accountHolderName': [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (formData.isSelfSubmitted === 2 && (!formData.isBankAccountExisting || formData.isEditingBankInfo)) {
        if (!input || removeSpace(input).length === 0) {
          return 'The input field is required';
        }
        if (input.length > 40) {
          return 'The input field is too long';
        }
        if (input.trim().split(' ').length < 2) {
          return 'Please enter your full name';
        }
        if (!/^[a-zA-Z\s-']+$/.test(input)) {
          return 'Please enter a valid name, with only letters, - and \'.';
        }
        return true;
      }
      return true;
    },
  }],
  'bankAccount.routingNumber': [
    {
      rule: 'required',
      isValid: (input, err, opt, formData) => {
        if (formData.isSelfSubmitted === 2 && (!formData.isBankAccountExisting || formData.isEditingBankInfo)) {
          if (!input) {
            return 'The input field is required';
          }

          if (numberUnmask(input).length < 9 || !formData.isValidRoutingNumber) {
            return 'Routing Number is not valid';
          }
        }
        return true;
      },
    },
  ],
  'bankAccount.accountNumber': [
    {
      rule: 'required',
      isValid: (input, err, opt, formData) => {
        if (formData.isSelfSubmitted === 2 && (!formData.isBankAccountExisting || formData.isEditingBankInfo)) {
          if (!input) {
            return 'The input field is required';
          }
        }
        return true;
      },
    },
  ],
  'bankAccount.accountType': [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (formData.isSelfSubmitted === 2 && (!formData.isBankAccountExisting || formData.isEditingBankInfo)) {
        if (!input) {
          return 'The input field is required';
        }
      }
      return true;
    },
  }],
  firstPaymentDate: [{
    rule: 'required',
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }

      if (numberUnmask(input).length < 8) {
        return 'First Payment Date is not valid';
      }

      if (!moment(input, 'MM/DD/YYYY').isValid()) {
        return 'First Payment Date is not valid';
      }

      const lowBound = moment().add(37, 'd');
      const upBound = moment().add(47, 'd');
      const inputDate = moment(input, 'MM-DD-YYYY');

      if (moment(inputDate).isBefore(lowBound, 'day') || moment(inputDate).isAfter(upBound, 'day')) {
        return `First Payment Date must be between ${lowBound.format('MM/DD/YYYY')} and ${upBound.format('MM/DD/YYYY')}.`;
      }
      return true;
    },
  }],
};
